import request from '@/utils/request'
import { upload } from '@/utils/request'

// 商务合作新增
export function postAddCooperationIntent(data) {
  return request({
    url: '/basic/Common/AddCooperationIntent',
    method: 'post',
    data
  });
}
// 专家特长技能
export function getExpertCategorys() {
  return request({
    url: '/basic/Common/ExpertCategorys',
    method: 'get'
  });
}


// 专家特长技能-专家信息
export function getExpertInfoCategorys(data) {
  return request({
    url: '/basic/Common/ExpertInfoCategorys',
    method: 'get',
    params:data
  });
}
// 专家库信息（新）
export function getExpertCategoryInfo(data) {
  return request({
    url: '/basic/Common/ExpertCategoryInfo',
    method: 'post',
    data
  });
}
// 专家查询
export function getExpertQuery(data) {
  return request({
    url: '/basic/Common/ExpertQuery',
    method: 'get',
    params:data
  });
}
// 供应商查询（名称or手机号）
export function getSupplierQuery(data) {
  return request({
    url: '/basic/Common/SupplierQuery',
    method: 'get',
    params:data
  });
}
// 项目类别
export function getProjectCategory() {
  return request({
    url: '/basic/Common/ProjectCategory',
    method: 'get'
  });
}
// 项目招标方式
export function getProjectMethod() {
  return request({
    url: '/basic/Common/ProjectMethod',
    method: 'get'
  });
}

// 文件上传
export function uploadFile(data) {
  return upload('/admin/File/upload', {}, data)
}

// 视频文件上传
export function uploadVideo(params,data) {
  return upload('/admin/File/videoupload', params, data)
}

// 获取文件详情
export function getFileDetail(id) {
  return request({
    url: '/admin/File/file/'+id,
    method: 'get',
  });
}

// 公告列表
export function getNoticeList(data) {
  return request({
    url: '/basic/Common/list',
    method: 'get',
    params:data
  });
}
// 公告列表-详情
export function getProjectNoticeDetail(data) {
  return request({
    url: '/basic/Common/ProjectNoticeDetail/'+data.id,
    method: 'get',
    params:data
  });
}
// 法律法规列表
export function getLawsRegulationList(data) {
  return request({
    url: '/basic/Common/LawsRegulationList',
    method: 'get',
    params:data
  });
}
// 法律法规列表-详情
export function getLawsRegulationDetail(data) {
  return request({
    url: '/basic/Common/LawsRegulationDetail/'+data.id,
    method: 'get',
    params:data
  });
}
// 附件下载/预览（附件）
export function getFileDownload(id, preview = false) {
  return request({
    url: '/admin/File/file/' + id,
    method: 'get',
    params: { preview },
    responseType: 'blob'
  });
}

// 视频下载/预览（视频）
export function getVideoDownload(data) {
  return request({
    url: '/admin/File/fileVideo',
    method: 'get',
    params: data
  });
}